var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassComposite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 180,
    viewBox: "0 0 273 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 180,
    fill: "url(#paint0_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 21,
    height: 180,
    fill: "url(#paint1_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    width: 21,
    height: 180,
    fill: "url(#paint2_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    width: 21,
    height: 180,
    fill: "url(#paint3_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 84,
    width: 21,
    height: 180,
    fill: "url(#paint4_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 105,
    width: 21,
    height: 180,
    fill: "url(#paint5_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 126,
    width: 21,
    height: 180,
    fill: "url(#paint6_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 147,
    width: 21,
    height: 180,
    fill: "url(#paint7_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 168,
    width: 21,
    height: 180,
    fill: "url(#paint8_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 189,
    width: 21,
    height: 180,
    fill: "url(#paint9_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 210,
    width: 21,
    height: 180,
    fill: "url(#paint10_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 231,
    width: 21,
    height: 180,
    fill: "url(#paint11_linear_10360_103189)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    width: 21,
    height: 180,
    fill: "url(#paint12_linear_10360_103189)",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10360_103189",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10360_103189",
    x1: 31.5,
    y1: 6.32812,
    x2: 31.5,
    y2: 169.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10360_103189",
    x1: 52.5,
    y1: 13.3594,
    x2: 52.5,
    y2: 158.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10360_103189",
    x1: 73.5,
    y1: 24.6094,
    x2: 73.5,
    y2: 144.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10360_103189",
    x1: 94.5,
    y1: 37.9688,
    x2: 94.5,
    y2: 158.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10360_103189",
    x1: 115.5,
    y1: 53.4375,
    x2: 115.5,
    y2: 165.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10360_103189",
    x1: 136.5,
    y1: 67.5,
    x2: 136.5,
    y2: 176.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10360_103189",
    x1: 157.5,
    y1: 54.1406,
    x2: 157.5,
    y2: 173.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10360_103189",
    x1: 178.5,
    y1: 37.9688,
    x2: 178.5,
    y2: 158.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10360_103189",
    x1: 199.5,
    y1: 24.6094,
    x2: 199.5,
    y2: 144.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10360_103189",
    x1: 220.5,
    y1: 13.3594,
    x2: 220.5,
    y2: 158.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10360_103189",
    x1: 241.5,
    y1: 6.32812,
    x2: 241.5,
    y2: 169.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10360_103189",
    x1: 262.5,
    y1: 0,
    x2: 262.5,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassComposite);
export default __webpack_public_path__ + "static/media/glass-composite.e159223f389509736486fa3c421727cb.svg";
export { ForwardRef as ReactComponent };